<template>
    <div>
        <div class="yl-flex">
			<div class="yl-flex" style="width: 380px">
				<Input v-model="name" style="width: 250px" placeholder="请输入名称">
					<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
            <Button class='ivu-btn-circle' type="primary" @click="addChannel">新增机构</Button>
        </div>
        <div style="margin-top: 20px;">
            <Table size="small" :columns="columns" :data="data">
                <template slot-scope="{row}" slot="action">
                    <div style="display: flex;  justify-content: center; align-items: center; height: 70px ;">
						<Button class='ivu-btn-circle' :data-id="row.id" @click="editOrganization" type="warning" size="small">编辑</Button>
						<Button class='ivu-btn-circle' :data-id="row.id" @click="delOrganization" style="margin-left: 10px" size="small">删除</Button>
					</div>
                </template>
                <template slot-scope="{row}" slot="logo">
                    <img :src="row.ext_info.logo" style="width: 50px; height: 50px"/>
                </template>
                <template slot-scope="{row}" slot="linkman">
					<div v-for="(item,index) in row.ext_info.linkman" :key="index">{{item.name}}</div>
                </template>
                <template slot-scope="{row}" slot="phone">
                    <div v-for="(item,index) in row.ext_info.linkman" :key="index">{{item.phone}}</div>
                </template>
            </Table>
			<div class="pager">
				<Page :total="count" :page-size="20" :current="page" @on-change="changePage"
					  size="small" show-total show-elevator/>
			</div>
        </div>
        <!-- 新增渠道 -->
        <Modal v-model="modal" width="900" ok-text="添加保存">
            <div style="display: flex;justify-content: space-around;">
                <div>
                    <div style=" color: #277dd3;display: flex;align-items: center;">
                        <span class="icon iconfont icon-jia" style="font-size: 24px;margin: 0 10px;"></span>
                        <span style="font-size: 18px; font-weight: bold;">新增渠道</span>
                    </div>
                    <div class="modal_list">
                        <div class="modal_list_title">渠道名称</div>
                        <Input v-model="add_channel_form.name" style="width: 300px"/>
                    </div>
                    <div class="modal_list">
                        <div class="modal_list_title">品牌logo</div>
                        <div style="display: flex; flex-direction: column; align-items: center;width: 300px; position: relative;">
                            <img @click="uploadLogo" :src="add_channel_form.ext_info.logo"
                                 style="border: 1px solid #DCDEE2; width: 120px; height: 120px; vertical-align: middle; margin-right: 5px"/>
                            <div style="width: 180px;font-size: 12px; color: #9F9E9E;">
                                建议尺寸为108*108，大小小于1M。支持JPG、PNG等图片格式
                            </div>
                        </div>
                    </div>
                    <div class="modal_list">
                        <div class="modal_list_title">渠道类型</div>
                        <Select v-model="add_channel_form.channel_type" style="width:300px">
                            <Option v-for="item in channel_type_list" :value="item.value" :key="item.value">{{
                                item.label }}
                            </Option>
                        </Select>
                    </div>
                </div>
                <div>
                    <div class="modal_list">
                        <div class="modal_list_title">地址</div>
                        <Input v-model="add_channel_form.ext_info.address" style="width: 300px"/>
                    </div>
                    <div class="modal_list">
                        <div class="modal_list_title">佣金比例</div>
                        <Input v-model="add_channel_form.brokerage_rate" style="width: 300px"/>
                    </div>
                    <div class="modal_list">
                        <div class="modal_list_title">渠道介绍及佣金说明</div>
                        <Input type="textarea" v-model="add_channel_form.ext_info.remark" style="width: 300px"/>
                    </div>
                    <div class="modal_list">
                        <div class="modal_list_title" style="display: flex; width: 300px;">
                            <div>渠道联系人姓名</div>
                            <div style="margin-left: 50px;">联系电话</div>
                        </div>
                        <div style="display: flex; width: 300px; align-items: center; margin: 10px 0;"
                             v-for="(item,index) in add_channel_form.ext_info.linkman" :key="index">
                            <Input v-model="add_channel_form.ext_info.linkman[index].name" style="width: 130px"/>
                            <Input v-model="add_channel_form.ext_info.linkman[index].phone"
                                   style="width: 130px;margin: 0 10px;"/>
                            <span v-if="index != '0' " class="icon iconfont icon-jian"
                                  style="font-size: 25px; color: #277dd3;" @click="minusLinkmanClick"
                                  :data-index="index"></span>
                        </div>
                        <span class="icon iconfont icon-jia" style="font-size: 25px; color: #277dd3;"
                              @click="addLinkmanClick"></span>
                    </div>
                </div>
            </div>
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
        </Modal>

        <Modal
                v-model="uploadModal"
                title="上传图片"
                @on-cancel="() => {uploadModal = false}"
                @on-ok="fileOk">
            <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
        </Modal>
    </div>
</template>

<script>
    import addFile from '../tool/addFile.vue';
	import {getOrganizationList, getOrganization, saveOrganization, delOrganization} from '@/api/runSet'
    import {mapGetters, mapActions} from "vuex";

    export default {
        name: "OrganizationManage",
        components: {addFile},
		computed:{
			...mapGetters(['userInfo', 'token']),
		},
		created(){
			this.getList();
		},
        data() {
            return {
				count: 0,
				page: 1,
                uploadModal: false,
                add_channel_form: {
                    name: '',
                    ext_info: {logo: require('../../assets/images/jia.svg'), remark: '', address: '', linkman: [{name:'', phone: ''}]},
                    channel_type: '',
                    brokerage_rate: '',
                },
                modal: false,
                name: '',
                channel_type_list: [
                    {
                        value: 1,
                        label: '银行'
                    },
                    {
                        value: 2,
                        label: '消费金融机构'
                    },
                    {
                        value: 3,
                        label: '小额贷款公司'
                    },
                    {
                        value: 4,
                        label: '其他'
                    }
                ],
                columns: [{
                    title: '渠道名称',
                    key: 'name',
                    align: 'center'
                },
                    {
                        title: '品牌logo',
                        slot: 'logo',
                        align: 'center'
                    },
                    {
                        title: '渠道类型',
                        key: 'channel_type_name',
                        align: 'center'
                    },
                    {
                        title: '渠道介绍及佣金说明',
                        key: 'remark',
                        align: 'center'
                    },
                    {
                        title: '渠道联系人',
                        slot: 'linkman',
                        align: 'center'
                    },
                    {
                        title: '联系电话',
                        slot: 'phone',
                        align: 'center'
                    },
                    {
                        title: '地址',
						key: 'address',
                        width: '150',
                        align: 'center'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center'
                    },
                ],
                data: []
            }
        },

        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
			search() {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.page = 1;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {token: that.token, page: that.page, name: that.name};
				let res = await getOrganizationList(that, data);
				if (res.code == 1) {
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			initFormData() {
            	this.add_channel_form = {
					name: '',
					ext_info: {logo: require('../../assets/images/jia.svg'), remark: '', address: '', linkman: [{name:'', phone: ''}]},
					channel_type: '',
					brokerage_rate: '',
				};
			},
            fileOk() {
                var that = this;
                that.add_channel_form.ext_info.logo = that.$refs['addFile'].fileUrl;
                that.$refs['addFile'].clear();
            },
            // 新增渠道
            addChannel() {
            	this.initFormData();
                this.modal = true
            },
            uploadLogo() {
                this.uploadModal = true
            },
            addLinkmanClick() {
                this.add_channel_form.ext_info.linkman.push({phone:'', name: ''})
            },
            minusLinkmanClick(e) {
                let index = e.currentTarget.dataset.index
                this.add_channel_form.ext_info.linkman.splice(index, 1)
            },
            editClick() {
                this.modal = true
            },
			save() {
				let that = this;
				this.throttle(async function() {
					let data = {token: that.token, data: that.add_channel_form};
					let res = await saveOrganization(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.modal = false;
						that.initFormData();
						that.getList();
					}
				}, 500)
			},
			// 编辑
			async editOrganization(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {token: that.token, id: id};
				let res = await getOrganization(that, data);
				if (res.code == 1) {
					that.add_channel_form = res.data.item;
					that.modal = true;
				}
			},
			// 删除
			delOrganization(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
							let data = {token: that.token, id: id}
							let res = await delOrganization(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
        }
    }
</script>

<style scoped lang="less">
    .modal_list {
        margin: 20px 0;

        .modal_list_title {
            margin-bottom: 5px;
        }
    }

    .yl-flex {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0;
    }

    .add_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    .add_title {
        margin: 0 10px;
        font-weight: bold;

    }

    .ivu-upload {
        display: flex;
        align-items: center;
    }
</style>
